<template>
  <div class="MainBox" @click.stop="SelectActive(-1,$self)">
    <div class="TableHead">
      <ul class="TableHeadLeft">
        <li class="TableHeadLeftRow btnStyleTwo blueBackColor btnRadius" @click="GoToPage('BusinessEdit')"><span
            class="icon iconfont iconicon-test20"></span>添加商户
        </li>
        <li class="TableHeadLeftRow btnStyleTwo blueBackColor btnRadius" @click="exportBusiness"><span
            class="icon iconfont el-icon-download"></span>导出商户列表
        </li>
        <!-- <li class="TableHeadLeftRow btnStyleTwo cyanBackColor btnRadius"><span class="icon iconfont iconicon-test49"></span>行业统计</li> -->
      </ul>
      <ul class="TableHeadRight">
        <div class="SearchBox">
          <input placeholder="输入商户名称查询" v-model="QueryName" v-on:keyup.13="QueryData(2)"/>
          <a class="SearchBtn" @click="QueryData(2)">搜索</a>
        </div>
        <div class="SearchBox">
          <input placeholder="输入商户编号查询" v-model="rootid" v-on:keyup.13="QueryData(3)"/>
          <a class="SearchBtn" @click="QueryData(3)">搜索</a>
        </div>
      </ul>
      <ul class="TableHeadRight" style="margin-right:20px;">
        <div class="SelectStyle" @click.stop="SelectActive(0,$self)">
          {{ SelectArr[0].datas[SelectArr[0].ix] }}
          <ul class="OptionStyleBox" v-if="SelectArr[0].active" :class="{ShowScrollBar:SelectArr[0].datas.length > 6}">
            <li class="OptionStyleRow" v-for="(item,index) in SelectArr[0].datas" v-bind:key="index" v-text="item"
                @click="SelectData(0,index)"></li>
          </ul>
          <a class="icon iconfont iconicon-test22 OptionStyleIcon"></a>
        </div>
      </ul>
      <ul class="clear"></ul>
    </div>

    <div class="TableMain">
      <table class="table StripeTable">
        <thead>
        <tr>
          <!-- <th>套餐类型</th> -->
          <th>商户ID</th>
          <th>商户类型</th>
          <th>商户名称</th>
          <th>行业</th>
          <th>套餐数</th>
          <th>生码量</th>
          <th>可生码数</th>
          <th>总生码量</th>
          <th>联系人</th>
          <th>用户名</th>
          <th>创建时间</th>
          <th>到期时间</th>
          <th>已同步</th>
          <th>操作</th>
        </tr>
        </thead>
        <tbody class="TRHoverStyle" v-if="datas">
        <tr v-for="(item,index) in datas" v-bind:key="index">
          <td v-text="item.rootid"></td>
          <!-- <td>
            <a v-if="item.user_package" v-text="item.user_package.name"></a>
            <a v-else>-</a>
          </td> -->
          <td>
            <a v-if="item.btype == 1">企业</a>
            <a v-if="item.btype == 2">个人</a>
          </td>
          <td v-text="item.name"></td>
          <td>
            <a v-if="item.trade" v-text="item.trade.trade_name"></a>
          </td>
          <td >
            <a v-if="item.user_package">{{ item.user_package.code_limit==-1?'无限': item.user_package.code_limit }}</a>
            <a v-else>-</a>
          </td>
          <td>
            <a v-if="item.user_package" v-text="item.user_package.created_code_limited"></a>
            <a v-else>-</a>
          </td>
          <td>
            <a v-if="item.user_package">{{ item.user_package.code_limit==-1?'无限': item.user_package.code_limit >0 ?item.user_package.code_limit - item.user_package.created_code_limited:0 }}</a>
            <a v-else>-</a>
          </td>
          <td>
            <a v-if="item.user_package" v-text="item.user_package.total_created_code_limited"></a>
            <a v-else>-</a>
          </td>
          <td>
            <a v-if="item.linkman" v-text="item.linkman"></a>
            <a v-else>-</a>
          </td>
          <td v-text="item.user_account.username"></td>
          <td v-text="item.created_at"></td>
          <td>
            <a class="redColor" v-if="item.user_package" v-text="item.user_package.due_date"></a>
            <a v-else>-</a>
          </td>
          <td>
            <a class="redColor" v-if="item.is_sync == 1">是</a>
            <a v-else>否</a>
          </td>
          <td>
            <div class="btnArray">
              <a class="btnStyleTwo btnRadius blueBackColor"
                 @click="GoToPage('BusinessDetail?id='+item.rootid)">商户设置</a>
              <a class="btnStyleTwo btnRadius greenBackColor" @click="SyncEnterprise(item)">工商同步</a>
              <a class="btnStyleTwo btnRadius cyanBackColor" @click="ChangePwd(item.user_account.uid)">重置密码</a>
              <!-- <a class="btnStyleTwo btnRadius redBackColor">禁用</a> -->
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <K-Transition :isLoding="isLoding" :subHint="subHint" v-if="!datas"></K-Transition>

      <!-- 分页器 -->
      <K-Paging :page="page" :totalPages="totalPages" @ChangePage="ChangePage" @SkipPage="SkipPage"></K-Paging>

    </div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

  </div>
</template>

<script>
var self;
import axios from 'axios'
import Paging from '@/components/common/Paging.vue'
import Transition from '@/components/common/Transition.vue'
import Toast from '@/components/common/Toast.vue'
import Loading from '@/components/common/Loading.vue'
import * as XLSX from 'xlsx';

export default {
  name: 'Business',
  components: {
    'K-Paging': Paging,
    'K-Loading': Loading,
    'K-Transition': Transition,
    'K-Toast': Toast
  },
  data() {
    return {
      $self: null,
      page: 1,
      loading: false,
      Toast: {
        state: false,
        type: 0,
        txt: null
      },
      subHint: '数据加载中...',
      isLoding: true,
      totalPages: 0,
      datas: null,
      QueryName: null,
      rootid: null,
      SelectArr: [{
        ix: 0,
        active: false,
        datas: ["全部", "企业", "个人"]
      }]
    }
  },
  created() {
    self = this;
    this.$self = this;
    axios.defaults.headers.common['token'] = localStorage.getItem("wwmxt_Token");
  },
  mounted() {
    self.GetList();
  },
  methods: {
    exportBusiness() {
      axios.post(self.GetServerUrl(1) + "business_list", {no_page: true})
          .then(function (response) {
            self.isLoding = false;
            const data = response.data.meta;
            const tableData = [];
            const headers = ['商户ID', '商户类型', '商户名称', '行业', '生码量', '联系人', '用户名', '到期时间'];
            if (data != null && data.length > 0) {
              data.forEach(item => {
                const tmpArr = [];
                tmpArr.push(item.rootid);
                if (item.btype == 1) {
                  tmpArr.push('企业');
                } else {
                  tmpArr.push('个人');
                }

                tmpArr.push(item.name);

                if (item.trade) {
                  tmpArr.push(item.trade.trade_name);
                } else {
                  tmpArr.push(' ');
                }

                if (item.user_package) {
                  tmpArr.push(item.user_package.created_code_limited + ' ');
                } else {
                  tmpArr.push('-');
                }

                if (item.linkman) {
                  tmpArr.push(item.linkman);
                } else {
                  tmpArr.push('-');
                }

                tmpArr.push(item.user_account.username);
                if (item.user_package) {
                  tmpArr.push(item.user_package.due_date + ' ');
                } else {
                  tmpArr.push('-');
                }

                tableData.push(tmpArr);
              });
            }

            tableData.unshift(headers);
            // 创建工作表
            const ws = XLSX.utils.aoa_to_sheet(tableData);
            const wscols = [
              { wch: 20 },
              { wch: 20 },
              { wch: 40 },
              { wch: 20 },
              { wch: 20 },
              { wch: 40 },
              { wch: 20 },
              { wch: 20 },
            ];
            ws['!cols'] = wscols;
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, '商户信息');
            XLSX.writeFile(wb, '商户信息.xlsx');

          }).catch(function (error) {
        self.subHint = self.ErrorHint(error);
        self.isLoding = false;
      });
    },
    ChangeToast() {
      self.Toast.state = false;
    },
    ToastFun(type, txt) {
      self.Toast.state = true;
      self.Toast.type = type;
      self.Toast.txt = txt;
    },
    ChangePage(data) {  //上下翻页
      if (data.te == 1) {
        if (self.page > 1) {
          self.page--
        }
      } else {
        if (self.page < self.totalPages) {
          self.page++
        }
      }
      self.GetList();
    },
    SkipPage(data) {  //跳转分页
      self.page = data.ix;
      self.GetList();
    },
    SelectData(ix, six) {  //选中选择框内容
      self.SelectArr[ix].ix = six;
      self.QueryData(1);
    },
    GetList() {
      self.datas = null;
      self.isLoding = true;
      axios.post(self.GetServerUrl(1) + "business_list", {page: self.page})
          .then(function (response) {
            self.datas = response.data.meta.data;
            self.isLoding = false;

            //总页数
            self.totalPages = response.data.meta.last_page;
          }).catch(function (error) {
        self.subHint = self.ErrorHint(error);
        self.isLoding = false;
      })
    },
    QueryData(te) {
      self.datas = null;
      self.isLoding = true;

      let datas;
      if (te == 1) {
        datas = {btype: self.SelectArr[0].ix};
      } else if (te == 2) {
        datas = {name: self.QueryName};
      } else if (te) {
        datas = {rootid: self.rootid};
      }
      console.log(datas);
      axios.post(self.GetServerUrl(1) + "business_list", datas)
          .then(function (response) {
            self.datas = response.data.meta.data;
            self.isLoding = false;

            //总页数
            self.totalPages = response.data.meta.last_page;
          }).catch(function (error) {
        self.subHint = self.ErrorHint(error);
        self.isLoding = false;
        self.datas = null;
      })
    },
    ChangePwd(uid) {
      self.loading = true;
      axios.patch(self.GetServerUrl(1) + "p_rest_password", {uid: uid})
          .then(function (response) {
            self.loading = false;
            self.ToastFun(0, response.data.message);  //弹窗提醒
          }).catch(function (error) {
        self.loading = false;
        self.ToastFun(2, self.ErrorHint(error));
      })
    },
    SyncEnterprise(item) {  //同步企业
      self.$confirm('确定要同步该企业【' + item.name + '】吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.loading = true;
        axios.post(self.GetServerUrl(1) + "operation_log/sync_enterprise", {token: 'oidzkll', rootid: item.rootid})
            .then(function (response) {
              self.loading = false;
              self.ToastFun(0, response.data.message);  //弹窗提醒
            }).catch(function (error) {
          self.loading = false;
          self.ToastFun(2, self.ErrorHint(error));
        })
      }).catch(() => {});
    }
  }
}
</script>

<style scoped>
.SelectStyle {
  width: 100px;
}

.TableHeadRight {
  display: flex;
  gap: 20px;
}
</style>
